/* Custom Gift Corner header + mobile drawer controller (vanilla, no deps). */
(function () {
  'use strict';
  var instances = [];
  var canHover = !!(window.matchMedia && window.matchMedia('(hover: hover)').matches);

  function arr(list) { return Array.prototype.slice.call(list || []); }
  function motion() { return window.CGCMotion || null; }

  function show(el, method, extra) {
    if (!el) return;
    el.setAttribute('data-cgc-open', '1');
    el.hidden = false;
    var m = motion();
    if (m && typeof m[method] === 'function') { try { m[method](el, extra); } catch (e) {} }
  }

  function hide(el, method, extra) {
    if (!el) return;
    el.setAttribute('data-cgc-open', '0');
    var done = function () { if (el.getAttribute('data-cgc-open') !== '1') el.hidden = true; };
    var m = motion();
    if (method && m && typeof m[method] === 'function') {
      var r;
      try { r = m[method](el, extra); } catch (e) { done(); return; }
      if (r && typeof r.then === 'function') r.then(done, done); else setTimeout(done, 450);
    } else done();
  }

  function create(root) {
    var scope = root.closest('.shopify-section') || document;
    var triggers = arr(root.querySelectorAll('[data-cgc-toggle][aria-controls]'));
    var depts = arr(root.querySelectorAll('[data-cgc-dept][aria-controls]'));
    var search = root.querySelector('[data-cgc-search]');
    var inputs = arr(root.querySelectorAll('[data-cgc-search-input]'));
    var drawer = scope.querySelector('[data-cgc-drawer]');
    var backdrop = scope.querySelector('[data-cgc-backdrop]');
    var openers = arr(scope.querySelectorAll('[data-cgc-drawer-open]'));
    var current = null, timer = 0, hoverOpenedAt = 0;
    var searchOpen = false, activeInput = null, suppressFocus = false;
    var drawerOpen = false, drawerOpener = null;

    function panelOf(t) { return t ? document.getElementById(t.getAttribute('aria-controls')) : null; }
    function inside(node) {
      if (!node) return false;
      if (root.contains(node)) return true;
      var p = panelOf(current);
      return !!(p && p.contains(node));
    }

    function openPanel(t, byHover) {
      if (current === t) return;
      if (current) closePanel(false);
      closeSearch();
      var p = panelOf(t);
      if (!p) return;
      show(p, 'openPanel', t);
      t.setAttribute('aria-expanded', 'true');
      current = t;
      hoverOpenedAt = byHover ? Date.now() : 0;
    }

    function closePanel(returnFocus) {
      clearTimeout(timer);
      if (!current) return;
      var t = current;
      current = null;
      t.setAttribute('aria-expanded', 'false');
      hide(panelOf(t), 'closePanel', t);
      if (returnFocus) t.focus();
    }

    function togglePanel(t) {
      clearTimeout(timer);
      if (current === t) {
        if (hoverOpenedAt && Date.now() - hoverOpenedAt < 400) return;
        closePanel(false);
      } else openPanel(t, false);
    }

    triggers.forEach(function (t) {
      if (!t.hasAttribute('aria-expanded')) t.setAttribute('aria-expanded', 'false');
      t.addEventListener('click', function (e) { e.preventDefault(); togglePanel(t); });
      t.addEventListener('keydown', function (e) {
        if (t.tagName !== 'BUTTON' && (e.key === ' ' || e.key === 'Spacebar')) { e.preventDefault(); togglePanel(t); }
      });
      if (canHover) {
        t.addEventListener('pointerenter', function (e) {
          if (e.pointerType && e.pointerType !== 'mouse') return;
          clearTimeout(timer);
          if (current === t) return;
          timer = setTimeout(function () { openPanel(t, true); }, 150);
        });
        t.addEventListener('pointerleave', function () { clearTimeout(timer); });
      }
    });

    arr(root.querySelectorAll('[data-cgc-close]')).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (search && search.contains(b) && searchOpen) { closeSearch(); if (activeInput) refocus(activeInput); return; }
        closePanel(true);
      });
    });

    function activateDept(btn) {
      var group = btn.parentElement ? arr(btn.parentElement.querySelectorAll('[data-cgc-dept][aria-controls]')) : [btn];
      group.forEach(function (b) {
        var on = b === btn;
        b.setAttribute('aria-expanded', on ? 'true' : 'false');
        var p = document.getElementById(b.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
    }

    depts.forEach(function (btn) {
      var dTimer = 0;
      btn.addEventListener('click', function (e) { e.preventDefault(); activateDept(btn); });
      if (canHover) {
        btn.addEventListener('pointerenter', function (e) {
          if (e.pointerType && e.pointerType !== 'mouse') return;
          clearTimeout(dTimer);
          dTimer = setTimeout(function () { activateDept(btn); }, 150);
        });
        btn.addEventListener('pointerleave', function () { clearTimeout(dTimer); });
      }
    });

    function refocus(input) { suppressFocus = true; input.focus(); suppressFocus = false; }

    function openSearch(input) {
      if (!search) return;
      activeInput = input;
      if (searchOpen) return;
      if (current) closePanel(false);
      searchOpen = true;
      show(search, 'openPanel', input);
      inputs.forEach(function (i) { if (i.hasAttribute('aria-controls')) i.setAttribute('aria-expanded', 'true'); });
    }

    function closeSearch() {
      if (!searchOpen) return;
      searchOpen = false;
      hide(search, 'closePanel', activeInput);
      inputs.forEach(function (i) { if (i.hasAttribute('aria-controls')) i.setAttribute('aria-expanded', 'false'); });
    }

    function inSearch(node) {
      if (!node) return false;
      if (search && search.contains(node)) return true;
      return inputs.some(function (i) { var f = i.form || i.parentElement; return f && f.contains(node); });
    }

    inputs.forEach(function (i) {
      i.addEventListener('focus', function () { if (!suppressFocus) openSearch(i); });
    });

    root.addEventListener('focusout', function (e) {
      var t = e.relatedTarget;
      if (!t) return;
      if (current && !inside(t)) closePanel(false);
      if (searchOpen && !inSearch(t)) closeSearch();
    });

    function lock(on) { document.documentElement.classList.toggle('cgc-drawer-lock', on); }

    function openDrawer(btn) {
      if (!drawer || drawerOpen) return;
      closePanel(false);
      closeSearch();
      drawerOpen = true;
      drawerOpener = btn || openers[0] || null;
      show(backdrop, null);
      show(drawer, 'openDrawer', backdrop);
      openers.forEach(function (o) { o.setAttribute('aria-expanded', 'true'); });
      lock(true);
      var c = drawer.querySelector('[data-cgc-drawer-close]');
      if (c) setTimeout(function () { try { c.focus({ preventScroll: true }); } catch (e) { c.focus(); } }, 30);
    }

    function closeDrawer(returnFocus) {
      if (!drawer || !drawerOpen) return;
      drawerOpen = false;
      hide(drawer, 'closeDrawer', backdrop);
      hide(backdrop, null);
      openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
      lock(false);
      if (returnFocus && drawerOpener) drawerOpener.focus();
    }

    openers.forEach(function (o) {
      if (!o.hasAttribute('aria-expanded')) o.setAttribute('aria-expanded', 'false');
      o.addEventListener('click', function (e) {
        e.preventDefault();
        if (drawerOpen) closeDrawer(true); else openDrawer(o);
      });
    });
    if (drawer) {
      arr(drawer.querySelectorAll('[data-cgc-drawer-close]')).forEach(function (c) {
        c.addEventListener('click', function (e) { e.preventDefault(); closeDrawer(true); });
      });
    }
    if (backdrop) backdrop.addEventListener('click', function () { closeDrawer(true); });

    var mq = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;
    function onMq(e) { if (e.matches) closeDrawer(false); }
    if (mq) { if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq); }

    return {
      root: root,
      onKey: function (e) {
        if (e.key !== 'Escape' && e.key !== 'Esc') return;
        if (drawerOpen) { e.preventDefault(); closeDrawer(true); return; }
        if (searchOpen) {
          var wasInside = inSearch(document.activeElement);
          closeSearch();
          if (wasInside && activeInput) refocus(activeInput);
          return;
        }
        if (current) { e.preventDefault(); closePanel(true); }
      },
      onClick: function (e) {
        var t = e.target;
        if (current && !inside(t)) closePanel(false);
        if (searchOpen && !inSearch(t)) closeSearch();
      },
      destroy: function () {
        clearTimeout(timer);
        if (drawerOpen) lock(false);
        if (mq) { if (mq.removeEventListener) mq.removeEventListener('change', onMq); else if (mq.removeListener) mq.removeListener(onMq); }
      }
    };
  }

  function initIn(container) {
    var roots = arr((container || document).querySelectorAll('[data-cgc-header]'));
    if (container && container.matches && container.matches('[data-cgc-header]')) roots.push(container);
    roots.forEach(function (root) {
      if (root.getAttribute('data-cgc-bound') === '1') return;
      root.setAttribute('data-cgc-bound', '1');
      instances.push(create(root));
    });
  }

  function prune(container) {
    instances = instances.filter(function (i) {
      var gone = !document.documentElement.contains(i.root) || (container && container.contains(i.root));
      if (gone) i.destroy();
      return !gone;
    });
  }

  document.addEventListener('keydown', function (e) { instances.forEach(function (i) { i.onKey(e); }); });
  document.addEventListener('click', function (e) { instances.forEach(function (i) { i.onClick(e); }); });
  document.addEventListener('shopify:section:unload', function (e) { prune(e.target); });
  document.addEventListener('shopify:section:load', function (e) { prune(null); initIn(e.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initIn(document); });
  } else initIn(document);
})();
